export default function Charters() {
  return (
    <div className="two-col">
      <div className="col-40">
        <h2>Charter ALAMAR Today!</h2>
        <div className="paragraph">
          All charters are managed by our friends at NorthPoint Yacht Charters.
        </div>
        <div className="paragraph">
          You can meet the Good Ship Alamar at Buck&apos;s Harbor Marine (see chart at right).
        </div>
        <div className="paragraph">
          Please click the button below to see our charter listing. Get ready to set sail!
        </div>
        <div style={{ marginTop: 10 }}>
          <a
            className="btn"
            href="https://www.northpointyachtcharters.com/charter-gallery/detail/76/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Click to Charter
          </a>
        </div>
      </div>

      <div className="col-60">
        <h2>...then start plotting your adventure!</h2>
        <iframe
          className="map-embed"
          src="https://maps.google.com/maps?q=44.33988,-68.73548&z=8&output=embed"
          title="Map"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </div>
  )
}
